import React, { useState } from "react";
import InfoCircleIcon from "../../../Common/Svgs/InfoCircleIcon";

const SpoiltMilkTooltip = () => {
  const [hover, setHover] = useState(false);

  return (
    <div>
      <div
        className="bg-[#FFF7DF66] py-1 px-2 flex items-center gap-x-2 rounded-md"
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <InfoCircleIcon size={16} className="text-dark-gray" />
        <p className="font-poppins font-medium text-xs text-black">Driver</p>
      </div>

      {hover && (
        <div className="absolute z-[999999] top-[-50px] left-[102px] bg-dark-gray px-3 py-2 rounded-md w-[200px]">
          <p className="font-aileron text-10 font-normal text-white text-center">
            Total milk spoilt by the driver, this will affect the driver
            commission calculation for this trip.{" "}
          </p>

          <div className="absolute left-3/4 -bottom-2 -translate-x-1/2 w-0 h-0 border-l-8 border-r-8 border-t-8 border-l-transparent border-r-transparent border-t-dark-gray" />
        </div>
      )}
    </div>
  );
};

export default SpoiltMilkTooltip;
